define('errors',["i18n"], function (i18n) {
    return {
        "AccountNotActivated": {
            title: i18n.t("Frontend.Aktivace"),
            content: i18n.t("Frontend.NeniMoznePridatNovyPrispevekProtozeJsiDosudNeaktivovalA"),
            buttons: [{
                text: i18n.t("Frontend.InformaceOAktivaci"),
                url: i18n.routes.accountActivation
            }]
        }
    }
});

